import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Menu, Transition } from "@headlessui/react";

import { classNames } from "@/helpers/classNames";

import getLanguageMetaData from "@/components/languages/get-language-meta-data";
import LinkWrapper from "@/components/linkWrapper";

const isObject = (o) => {
  return o && typeof o === "object" && !Array.isArray(o);
};

function LanguageSwitcherMenu({
  currentLanguage = "default",
  languageLinks = {},
  className = "",
  showFlag = false,
}) {
  const languageLinksEntries =
    (isObject(languageLinks) && Object.entries(languageLinks)) || [];

  if (!languageLinksEntries?.length) {
    return <></>;
  }

  return (
    <Menu
      as="div"
      className={classNames("relative inline-block text-left", className)}
    >
      <div>
        <Menu.Button className="flex w-full items-center justify-center bg-background-transparent text-base font-medium focus:outline-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            className="mr-1 h-5 w-5 pb-1"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{getLanguageMetaData(currentLanguage).nativeName}</span>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-40 origin-top-right divide-y divide-gray-100 rounded-md bg-background-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {Boolean(languageLinksEntries?.length) &&
            languageLinksEntries.sort().map(([locale, url], index) => {
              const languageMetaData = getLanguageMetaData(locale);
              return (
                <div key={index} className="py-1">
                  <Menu.Item>
                    {() => (
                      <LinkWrapper
                        to={currentLanguage === locale ? null : url}
                        className={classNames(
                          "group flex items-center rounded-md px-4 py-2 text-sm text-text-dark-gray hover:bg-background-light-gray",
                          currentLanguage === locale
                            ? "bg-background-light-gray"
                            : ""
                        )}
                      >
                        {showFlag && (
                          <div className="mr-3 w-5" aria-hidden="true">
                            {languageMetaData.flag}
                          </div>
                        )}
                        {languageMetaData.nativeName}
                      </LinkWrapper>
                    )}
                  </Menu.Item>
                </div>
              );
            })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

LanguageSwitcherMenu.propTypes = {
  currentLanguage: PropTypes.string,
  languageLinks: PropTypes.object,
  className: PropTypes.string,
  showFlag: PropTypes.bool,
};

export default LanguageSwitcherMenu;
